/* eslint-disable no-console */

const PREFIX = '[StaffClientDebug]';

/**
 * Temporary diagnostics for staff client-list / Drop-In access issues.
 * Uses console.warn so logs appear in production (logger.debug is suppressed there).
 */
export function staffClientDebug(step, payload = {}) {
  console.warn(PREFIX, step, {
    ...payload,
    at: new Date().toISOString()
  });
}

export function staffClientDebugUid(uid) {
  if (!uid || typeof uid !== 'string') {
    return 'unknown';
  }
  return `…${uid.slice(-8)}`;
}
